import React, { useState } from 'react';
import { Box } from '@mui/material';
import ModalForm from '../ModalBlock/ModalForm/ModalForm';
import ConsultationForm from '../Forms/SpecificForms/ConsultationForm';
import Dates from '../Dates/Dates';

const styles = {
  dateBlock: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    marginBottom: '24px',
  },
};

const formDataMain = {
  sentContent: {
    title: 'Успешно записаны на программу!',
    message: 'Скоро с вами свяжется куратор',
  },
};

function ProgramRequestModal({
  extraLeadData,
  startDate,
  endDate,
  date,
  formData,
  ymSubmitEventTypes,
  ymSubmitExtraEventType,
  myTargetSubmitEventTypes,
}) {
  const [isFormSent, setIsFormSent] = useState(false);
  const [isError, setIsError] = useState(false);

  return (
    <ModalForm
      {...formData}
      {...formDataMain}
      isSent={isFormSent}
      isError={isError}
    >
      {startDate && endDate && (
        <Box sx={styles.dateBlock}>
          <Dates startDate={startDate} endDate={endDate} />
        </Box>
      )}

      <ConsultationForm
        setIsSent={setIsFormSent}
        setIsError={setIsError}
        extraLeadData={{ ...extraLeadData, date: date?.slice(0, 10) }}
        buttonLabel="оставить заявку"
        ymSubmitEventTypes={ymSubmitEventTypes}
        ymSubmitExtraEventType={ymSubmitExtraEventType}
        myTargetSubmitEventTypes={myTargetSubmitEventTypes}
      />
    </ModalForm>
  );
}

export default ProgramRequestModal;
